import React, { useState } from 'react';

const LPFAQ = ({ items = [], accentColor = 'lp-rose' }) => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (i) => setOpenIndex(openIndex === i ? null : i);

  const colorMap = {
    'lp-rose': 'text-lp-rose',
    'lp-sage': 'text-lp-sage',
  };
  const accent = colorMap[accentColor] || colorMap['lp-rose'];

  return (
    <div className="space-y-3">
      {items.map((item, i) => (
        <div key={i} className="bg-white rounded-xl border border-lp-border overflow-hidden">
          <button
            onClick={() => toggle(i)}
            className="w-full px-6 py-5 text-left flex justify-between items-center hover:bg-lp-gray/50 transition-colors"
          >
            <span className="text-sm md:text-base font-medium text-lp-charcoal pr-4">
              {item.question}
            </span>
            <span className={`${accent} text-xl transform transition-transform duration-300 flex-shrink-0 ${openIndex === i ? 'rotate-45' : ''}`}>
              +
            </span>
          </button>
          <div className={`overflow-hidden transition-all duration-300 ${openIndex === i ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'}`}>
            <div className="px-6 pb-5 text-sm text-lp-charcoal-mid leading-relaxed">
              {item.answer}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default LPFAQ;
